import React from 'react';
import { Box, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
interface StatusBadgeProps {
    /**Determines the status type for the StatusBadge */
    statusType: 'admin-user' | 'creative' | 'custom';
    /**the custom status to switch to based on external logic */
    customStatusType?: 'positive' | 'negative' | 'neutral';
    /**The status that is indicated for positive */
    customStatusPositive?: string;
    /**The status that is indicated for neutral */
    customStatusNeutral?: string;
    /**The status that is indicated for negative */
    customStatusNegative?: string;
    /**used to set status indicator for users */
    active?: boolean; // Pass true for "Active", false for "Out of Stock"
    /**used to set status indicator for projects and similar */
    projectStatus?: 'published' | 'draft';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
    statusType,
    active,
    projectStatus,
    customStatusType,
    customStatusPositive,
    customStatusNeutral,
    customStatusNegative,
}) => {
    const { themeStyle } = useThemeContext();

    if (statusType === 'admin-user') {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: 'fit-content',
                    gap: 1,
                    padding: '4px 12px',
                    borderRadius: '16px',
                    border: `1px solid ${
                        active
                            ? theme[themeStyle].green_status_indicator_full
                            : theme[themeStyle].red_status_indicator_full
                    }`,
                    backgroundColor: active
                        ? theme[themeStyle].green_status_indicator
                        : theme[themeStyle].red_status_indicator,
                    color: active
                        ? theme[themeStyle].green_status_indicator_full
                        : theme[themeStyle].red_status_indicator_full,
                }}>
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: active
                            ? theme[themeStyle].green_status_indicator_full
                            : theme[themeStyle].red_status_indicator_full,
                    }}
                />
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        fontSize: '12px',
                    }}>
                    {active ? 'Active' : 'InActive'}
                </Typography>
            </Box>
        );
    }

    if (statusType === 'custom') {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: 'fit-content',
                    gap: 1,
                    padding: '4px 12px',
                    borderRadius: '16px',
                    border: `1px solid ${
                        customStatusType === 'positive'
                            ? theme[themeStyle].green_status_indicator_full
                            : customStatusType === 'neutral'
                            ? theme[themeStyle].yellow_status_indicator_full
                            : theme[themeStyle].red_status_indicator_full
                    }`,
                    backgroundColor:
                        customStatusType === 'positive'
                            ? theme[themeStyle].green_status_indicator
                            : customStatusType === 'neutral'
                            ? theme[themeStyle].yellow_status_indicator
                            : theme[themeStyle].red_status_indicator,
                    color:
                        customStatusType === 'positive'
                            ? theme[themeStyle].green_status_indicator_full
                            : customStatusType === 'neutral'
                            ? theme[themeStyle].yellow_status_indicator_full
                            : theme[themeStyle].red_status_indicator_full,
                }}>
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor:
                            customStatusType === 'positive'
                                ? theme[themeStyle].green_status_indicator_full
                                : customStatusType === 'neutral'
                                ? theme[themeStyle].yellow_status_indicator_full
                                : theme[themeStyle].red_status_indicator_full,
                    }}
                />
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        fontSize: '12px',
                    }}>
                    {customStatusType === 'positive'
                        ? customStatusPositive
                        : customStatusType === 'neutral'
                        ? customStatusNeutral
                        : customStatusNegative}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: 'fit-content',
                gap: 1,
                padding: '4px 12px',
                borderRadius: '16px',
                border: `1px solid ${
                    projectStatus === 'published'
                        ? theme[themeStyle].green_status_indicator_full
                        : theme[themeStyle].yellow_status_indicator_full
                }`,
                backgroundColor:
                    projectStatus === 'published'
                        ? theme[themeStyle].green_status_indicator
                        : theme[themeStyle].yellow_status_indicator,
                color:
                    projectStatus === 'published'
                        ? theme[themeStyle].green_status_indicator_full
                        : theme[themeStyle].yellow_status_indicator_full,
            }}>
            <Box
                sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor:
                        projectStatus === 'published'
                            ? theme[themeStyle].green_status_indicator_full
                            : theme[themeStyle].yellow_status_indicator_full,
                }}
            />
            <Typography
                variant="body2"
                sx={{
                    fontWeight: 500,
                    fontSize: '12px',
                }}>
                {projectStatus === 'published' ? 'published' : 'draft'}
            </Typography>
        </Box>
    );
};
